import React, { JSX } from 'react';
import AppHeader from '../../common/app-header/AppHeader';
import HomePageBlock from './HomePageBlock';

const HomePage = (): JSX.Element => {
  //const token = localStorage.getItem('access_token');

  /*if (!token) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }*/

  return (
    <>
      <AppHeader />
      <HomePageBlock />
    </>
  );
};

export default HomePage;
